// extracted by mini-css-extract-plugin
module.exports = {"container":"EventTagList_container__ECe9D","tag":"EventTagList_tag__39tKN"};